import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmModal = ({
  open,
  setOpen,
  message,
  options = [],
  callbacks = [],
  buttonStyles = [],
  style,
  size = 'sm',
  closeAction = () => setOpen(false),
}) => {
  const { zIndex: _ignoredZIndex, ...modalStyle } = style ?? {};

  return (
    <Modal
      show={open}
      onHide={closeAction}
      centered
      size={size}
      contentClassName="bg-transparent border-0 shadow-none"
      backdropClassName="modal-stack-2"
      style={{ ...modalStyle, '--bs-modal-zindex': 'var(--z-modal-2)' }}
    >
      <Modal.Body
        className="w-100 rounded-4 p-5 align-items-center justify-content-center overflow-auto"
        style={{
          backgroundColor: 'white',
          color: 'black',
          userSelect: 'none',
        }}
      >
        {/* Message */}
        <div className="text-center">
          <div>{message}</div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-row w-100 mt-3 justify-content-center gap-2 flex-wrap">
          {options.map((option, index) => (
            <div
              key={index}
              className="px-3 py-2 rounded-4"
              style={{
                color: 'var(--color-font)',
                backgroundColor: 'var(--color-background)',
                cursor: 'pointer',
                ...buttonStyles[index],
              }}
              onClick={() => callbacks[index]?.()}
            >
              {option}
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;
